import { Select, Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import QueryString from 'qs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { getBanners } from '../../../api/banner.api';
import Button from '../../../components/Button';
import ErrorResponse from '../../../components/ErrorResponse';
import CampusDetailModal from '../../../components/homepage/top-banner/modals/CampusDetailModal';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import Pagination from '../../../components/Pagination';
import SelectCampus from '../../../components/SelectCampus';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import config from '../../../lib/config';
import { getCommonCodeLabel } from '../../../lib/store';
import { IBannerItem, IGetBanners } from '../../../models/banner.model';
import { RootState } from '../../../store/rootReducer';

const TopBanner = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { data: res, isLoading, error, execute } = useAxios<IGetBanners>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetBanners>();

  const [campusCode, setCampusCode] = useState<string | undefined>();
  const [title, setTitle] = useState('');

  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [param, setParam] = useState({});
  const [campusDetailVisible, setCampusDetailVisible] = useState(false);
  const [campusCodes, setCampusCodes] = useState<any>([]);

  useEffect(() => {
    execute(getBanners({ bannerGBN: 'TO' }));
    execute2(getBanners({ bannerGBN: 'FR' }));
  }, []);

  useEffect(() => {
    if (auth && res && !isLoading && res2 && !isLoading2) {
      const _param: any = {};
      let _data: IBannerItem[] = _.union(res.data, res2.data);
      _data.sort((a, b) =>
        a.bannerCode > b.bannerCode ? -1 : a.bannerCode < b.bannerCode ? 1 : 0,
      );

      if (query.page) {
        const _page = Number(query.page);
        setPage(_page);
        _param.page = _page;
      }
      if (auth.hqYn === 'N' && currentCampus) {
        _data = _data.filter((item) =>
          item.campuses.some(
            (subitem) => subitem?.campusCode === currentCampus,
          ),
        );
      } else if (auth.hqYn === 'Y' && query.campusCode) {
        const _campusCode = String(query.campusCode);
        setCampusCode(_campusCode);
        _param.campusCode = _campusCode;
        _data = _data.filter((item) =>
          item.campuses.some((subitem) => subitem?.campusCode === _campusCode),
        );
      }
      if (query.title) {
        const _title = String(query.title);
        setTitle(_title);
        _param.title = _title;
        _data = _data.filter((item) => item.title.includes(_title));
      }

      setParam(_param);
      setData(_data);
    }
  }, [location, auth, currentCampus, res, isLoading, res2, isLoading2]);

  const onSearch = () => {
    const param: any = { page: 1 };

    if (campusCode) param.campusCode = campusCode;
    if (title) param.title = title;

    setParam(param);
    history.push(`/homepage/top-banner?${QueryString.stringify(param)}`);
  };

  const columns: TableColumnsType<IBannerItem> = [
    {
      title: t('homepage.archive.column1'),
      dataIndex: 'bannerCode',
      key: 'bannerCode',
      align: 'center',
      width: '6%',
      sorter: (a, b) => a.bannerCode - b.bannerCode,
    },
    {
      title: t('common.column.status'),
      dataIndex: 'srtDate',
      key: 'srtDate',
      align: 'center',
      width: '6%',
      render: (value, record) => {
        if (moment().isBefore(moment(record.srtDate))) {
          return t('homepage.topBanner.text1');
        } else if (moment().isAfter(moment(record.endDate))) {
          return t('homepage.topBanner.text2');
        } else {
          return t('homepage.topBanner.text3');
        }
      },
    },
    {
      title: t('homepage.surveyQuestion.column2'),
      dataIndex: 'openYN',
      key: 'openYN',
      align: 'center',
      width: '10%',
    },
    {
      title: t('common.column.category'),
      dataIndex: 'bannerGBN',
      key: 'bannerGBN',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.bannerGBN?.localeCompare(b.bannerGBN),
      render: (value) => getCommonCodeLabel('HP0001', value, 'ko'),
    },
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => a.title?.localeCompare(b.title),
      render: value => {
        return <div className="text-left ant-table-cell-ellipsis">{value}</div>
      }
    },
    {
      title: t('event.education.column11'),
      dataIndex: 'allCampusYN',
      key: 'allCampusYN',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.allCampusYN?.localeCompare(b.allCampusYN),
      render: (value, record: any) => {
        let render;

        if (value === 'Y') {
          render = t('common.text.all');
        } else if (record.campuses?.length === 1) {
          render = record.campuses[0].campusName;
        } else {
          render = (
            // eslint-disable-next-line
            <a
              className="download-link"
              onClickCapture={(event) => {
                event.stopPropagation();
                setCampusCodes(
                  record.campuses.map((item: any) => item.campusCode),
                );
                setCampusDetailVisible(true);
              }}
            >
              {t('common.button.detail')}
            </a>
          );
        }

        return render;
      },
    },
    {
      title: t('common.column.writer'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
    },
    {
      title: t('homepage.mainBanner.column1'),
      dataIndex: 'srtDate',
      key: 'srtDate',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.srtDate?.localeCompare(b.srtDate),
      render: (value, record) => (
        <>
          {moment(value).format('YYYY.MM.DD')} ~{' '}
          {moment(record.endDate).format('YYYY.MM.DD')}
        </>
      ),
    },
    {
      title: t('homepage.archive.column5'),
      dataIndex: 'firstRegDttm',
      key: 'firstRegDttm',
      align: 'center',
      width: '10%',
      sorter: (a, b) => a.firstRegDttm?.localeCompare(b.firstRegDttm),
      render: (value) => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-homepage-big.svg"
      parentMenu={t('common.menu.homepage')}
      currentMenu={t('homepage.topBanner.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              {auth.hqYn === 'Y' ? (
                <SelectCampus
                  placeholder={t('common.menu.campus')}
                  value={campusCode}
                  onChange={(value: string) => setCampusCode(value)}
                  hasAll={true}
                />
              ) : (
                <SelectCampus />
              )}
            </div>
          </li>
          <li>
            <label>{t('common.column.title')}</label>
            <input
              type="text"
              className="form-control w-150p"
              placeholder={t('homepage.archive.placeholder1')}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading || isLoading2 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">{t('common.text.count')}: <b>{data.length}</b>{t('common.text.unit')}</div>
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/homepage/top-banner/create')}
              text={t("homepage.archive.button1")}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  history.push(`/homepage/top-banner/${record.bannerCode}`);
                },
              };
            }}
            rowClassName="pointer"
            rowKey="smsSendCode"
          />
        </div>
        <div className="comm-bx__between">
          <div />
          <div className="common-paging center">
            <Pagination
              count={data.length}
              page={page}
              param={param}
              path="/homepage/top-banner"
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/homepage/top-banner/create')}
              text={t('homepage.archive.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
      </div>

      {campusDetailVisible && (
        <CampusDetailModal
          visible={campusDetailVisible}
          setVisible={setCampusDetailVisible}
          campusCodes={campusCodes}
        />
      )}
    </div>
    </>
  );
};

export default TopBanner;
